import {
  SET_LOGGED_USER,
  LOGGED_USER_KEY,
} from '../../types/user.types'

export default {
  [SET_LOGGED_USER]: (state, payload) => {
    state[LOGGED_USER_KEY] = payload
  },
}
